import Vue from 'vue'
import Vuex from 'vuex'
import mainSearch from './module/mainSearch'
import orderingDialog from './module/orderingDialog'
import listSearch from './module/listSearch'
import toggleMenu from './module/toggleMenu'
import singalDialog from './module/singalDialog'
import analyzeDialog from './module/analyzeDialog'
import deduceDialog from './module/deduceDialog'
import pactTotal from './module/pactTotal'
import userReturnBack from './module/userReturnBack'
import infer from './module/infer'
import submitOrder from './module/submitOrder'
import meetingDetail from './module/meetingDetail'
import global from './module/global'

Vue.use(Vuex);
export default new Vuex.Store({
	modules : {
		mainSearch,orderingDialog,listSearch,
		toggleMenu,singalDialog,analyzeDialog,deduceDialog,pactTotal,userReturnBack,infer,submitOrder,meetingDetail,global
	}
})



// WEBPACK FOOTER //
// ./src/storage/vuex/index.js